import React from 'react';

import { StyledImageIcon } from '@pkg/components/Sections/Profile/ImageIcon/styles';

interface ImageIconProps {
    src: string;
    altText?: string;
}

export const ImageIcon = ({ src, altText = 'Image Icon' }: ImageIconProps) => {
    return <StyledImageIcon src={src} alt={altText} />; //todo - better default alt
};
